import { render, staticRenderFns } from "./SuppliesDeclarations.vue?vue&type=template&id=13a46016&scoped=true&"
import script from "./SuppliesDeclarations.vue?vue&type=script&lang=js&"
export * from "./SuppliesDeclarations.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesDeclarations.vue?vue&type=style&index=0&id=13a46016&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a46016",
  null
  
)

export default component.exports